import keyMirror from '../services/key_mirror';

export default keyMirror([
  'USER_LOADED',
  'LOGOUT',
  'SLACK_TEAM_LOADED',
  'SLACK_CHANNELS_LOADED',
  'SLACK_CHANNELS_UPDATED',
  'SLACK_CHANNEL_ADDED_TO_BLACKLIST',
  'SLACK_CHANNEL_REMOVED_FROM_BLACKLIST',
  'DEVICES_LOADED',
  'DEVICE_PAIR_STARTED',
  'DEVICE_PAIR_FAILED',
  'DEVICE_PAIR_SUCCEEDED',
  'DEVICE_UNPAIRED',
  'FACEBOOK_PAGES_LOADED',
  'FACEBOOK_PAGE_ADDED',
  'FACEBOOK_PAGE_REMOVED',
  'FACEBOOK_PAGE_UPDATED',
  'FACEBOOK_INVALID_ID_ADDED',
  'FACEBOOK_ADD_DIALOG_OPENED',
  'NOTIFICATION_ADDED',
  'NOTIFICATION_SHOWN',
  'INVITES_LOADED',
  'INVITE_GENERATED',
  'INVITE_REVOKED',
  'INVITE_RESOLVED',
  'WEBEX_USER_LOADED',
  'WEBEX_CHANNELS_UPDATED',
  'WEBEX_CHANNELS_LOADED',
  'WEBEX_CHANNEL_ADDED_TO_BLACKLIST',
  'WEBEX_CHANNEL_REMOVED_FROM_BLACKLIST',
], 'dashboard');



// WEBPACK FOOTER //
// ./src/actions/action_types.js